import { render, staticRenderFns } from "./PostSortable.vue?vue&type=template&id=22cdef1a&scoped=true&"
import script from "./PostSortable.vue?vue&type=script&lang=js&"
export * from "./PostSortable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cdef1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VFlex,VLayout,VRadio,VRadioGroup,VSelect})
